import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators/map";
import { catchError } from "rxjs/operators/catchError";
import { UserService } from "@core/store/user/user.service";
import * as UserActions from "./user.actions";
import { LoadUserSuccessAction } from "./user.actions";
import { User } from "@core/store/user/user.model";

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
    private notificationService: NotificationsService,
    private translate: TranslateService,
  ) {}

  @Effect()
  load$: Observable<Action> = this.actions$
    .ofType(UserActions.ActionTypes.LOAD)
    .switchMap(() => {
      return this.userService.me().pipe(
        map((_settings) => new UserActions.LoadUserSuccessAction(_settings)),
        catchError(() => Observable.of(new UserActions.LoadUserFailAction())),
      );
    });

  @Effect({ dispatch: false })
  load_success$ = this.actions$
    .ofType(UserActions.ActionTypes.LOAD_SUCCESS)
    .map((action: LoadUserSuccessAction) => action.payload)
    .do((user: User) => {
      const lang = user.settings.language.substring(0, 2);
      this.translate.use(lang);
    });
}



// WEBPACK FOOTER //
// /app/src/app/core/store/user/user.effects.ts